import { useWorkoutEditStore } from "./WorkoutEditContext";

interface LogSetProgressValuePayload {
  workoutSetId: string;
  exerciseAttributeId: string;
  trackedValue: string;
}

export function useLogSetProgressValue() {
  const workoutEditStore = useWorkoutEditStore();

  function logSetProgressValue(payload: LogSetProgressValuePayload) {
    workoutEditStore.logSetProgressValue(
      payload.workoutSetId,
      payload.exerciseAttributeId,
      payload.trackedValue,
    );
  }

  return logSetProgressValue;
}
